import { useMutation } from 'react-query';

import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

import { AdditionalCompensations } from '../types';

export const cancelAdditionalCompensation = ({ id }: { id: number }) =>
  axios.put(`${API_BASE_PATH}/payroll/additional-compensations/${id}/cancel`);

type UseCancelAdditionalCompensationOptions = {
  config?: MutationConfig<typeof cancelAdditionalCompensation>;
};

export const useCancelAdditionalCompensation = ({
  config,
}: UseCancelAdditionalCompensationOptions = {}) => {
  return useMutation({
    onMutate: async (cancelAdditionalCompensation) => {
      await queryClient.cancelQueries('additional-compensations');

      const previousAdditionalCompensations = queryClient.getQueryData<AdditionalCompensations>(
        'additional-compensations'
      );

      queryClient.setQueryData(
        'additional-compensations',
        previousAdditionalCompensations?.data?.filter(
          (additionalCompensation) => additionalCompensation.id !== cancelAdditionalCompensation.id
        )
      );

      return { previousAdditionalCompensations };
    },
    onError: (_, __, context: any) => {
      if (context?.previousAdditionalCompensations) {
        queryClient.setQueryData(
          'additional-compensations',
          context.previousAdditionalCompensations
        );
      }
    },
    onSuccess: () => queryClient.invalidateQueries('additional-compensations'),
    ...config,
    mutationFn: cancelAdditionalCompensation,
  });
};
